import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { DEFAULTS } from "@/data/contentRegistry";

export default function CTABand({ eyebrow, title, subtitle, primaryLabel, primaryTo = "/contact", secondaryLabel, secondaryTo = "/methode" }) {
  const { content } = useContent();
  const fallback = content?.["home.cta.eyebrow"] || DEFAULTS["home.cta.eyebrow"] || "Prêt à échanger ?";
  const finalEyebrow = eyebrow || fallback;
  return (
    <section data-testid="cta-band" className="relative overflow-hidden bg-ducs-navy">
      <div className="absolute inset-0 dijon-pattern opacity-50" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 py-20 md:py-28 grid gap-10 md:grid-cols-2 items-center">
        <div>
          <div className="label-caps mb-4">{finalEyebrow}</div>
          <h2 className="font-serif text-3xl md:text-4xl text-ducs-cream leading-tight">{title}</h2>
          {subtitle && <p className="mt-4 text-ducs-mist max-w-xl whitespace-pre-line">{subtitle}</p>}
        </div>
        <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
          <Link to={primaryTo} className="btn-primary" data-testid="cta-primary">{primaryLabel || "Demander un audit"}</Link>
          <Link to={secondaryTo} className="btn-secondary" data-testid="cta-secondary">{secondaryLabel || "Découvrir nos solutions"}</Link>
        </div>
      </div>
    </section>
  );
}
